import { render, staticRenderFns } from "./PackageItems.vue?vue&type=template&id=8511b9f4&"
import script from "./PackageItems.vue?vue&type=script&lang=js&"
export * from "./PackageItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports